module.exports = __webpack_public_path__ + "fonts/sourcesansproitalic.d2d359c5.woff";